let SWAL;
export default async function swal(...args) {
    if (!process.client) {
        return Promise.reject();
    }
    let swal = SWAL;
    if (!swal) {
        try {
            swal = (await import("sweetalert")).default;
            SWAL = swal;
        }
        catch (e) { }
    }
    if (!swal) {
        if ("object" == typeof args[0]) {
            const opts = args[0];
            return confirm("" + (opts.title || "") + ". " + (opts.text || ""));
        }
        const title = args[0];
        const description = args[1];
        return confirm("" + title + ". " + description);
    }
    return swal(...args);
}
export function getSweetalert() {
    return SWAL;
}
